import UpdateTrainingSession from "../../components/addTraining";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";

const UpdateTraining = () => {
  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>
        <UpdateTrainingSession type={"EDIT"} />
      </Styled.ColumnDiv>
    </Styled.MainDiv>
  );
};

export default UpdateTraining;
